<app-alert level="danger" *ngIf="error">{{error}}</app-alert>
<div #container></div>
